import { z } from "zod";
import { ADDRESS_MAX, POSTCODE_MAX } from "./limits";
import { maxLengthMessage } from "./messages";
import { EnumType } from "../types";

export const Countries = {
    Australia: "Australia",
    NewZealand: "New Zealand",
} as const;
export type Country = EnumType<typeof Countries>;

export const addressSchema = z.object({
    country: z.enum(Object.values(Countries)).optional(),
    address: z
        .string()
        .max(ADDRESS_MAX, maxLengthMessage("Address", ADDRESS_MAX))
        .optional(),
    suburb: z.string().optional(),
    state: z.string().optional(),
    region: z.string().optional(),
    postcode: z
        .string()
        .max(POSTCODE_MAX, maxLengthMessage("Postcode", POSTCODE_MAX))
        .optional(),
});

export type Address = z.infer<typeof addressSchema>;
